export const ZAMPLIA_SURVEYS_VENDOR__ID = "1220228VENDOR1662983969646";
export const ZAMPLIA_SURVEYS_VENDOR_ID = "313";
export const IP_REGISTRY_KEY = "25B0A5232A362AD0100C10234E2B485D";
export const IP_URL = "https://api.ip2location.io/";